import Repository from '../axios'

export default {
  fetchActionStatusLogs(object_name, object_id) {
    return Repository.get(`/${object_name}/${object_id}/statusLogs`)
  },
  updateActionStatus(object_name, object_id, payload) {
    return Repository.put(`/${object_name}/${object_id}/statusLogs`, payload)
  },
  getActionAttachments(object_name, object_id) {
    return Repository.get(`/${object_name}/${object_id}/attachments`)
  },
  uploadAttachment(object_name, object_id, payload) {
    return Repository.post(`/${object_name}/${object_id}/attachments`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteActionAttachment(object_name, object_id, attachment_id) {
    return Repository.delete(`/${object_name}/${object_id}/attachments/${attachment_id}`)
  },
    
  //assessment actions endpoints
  getAssessmentActions(assessment_type, assessment_id) {
    return Repository.get(`/action/assessment/${assessment_type}/${assessment_id}`)
  },
  getAvailableActionsToLink(object_name, company_id) { 
    return Repository.get(`/${object_name}/available-actions-to-link`, {
      params: { company_id }
    })
  },
  removeActionFromAssessment(action_id, assessment_type, only_unlink = false) {
    return Repository.delete(`/action/${action_id}/assessment/${assessment_type}?only_unlink=${only_unlink}`)
  },
  updateActionStatusLog(action_id, log_id, payload) {
    return Repository.put(`/action/${action_id}/statusLogs/${log_id}`, payload)
  },
  deleteActionStatuslog(action_id, log_id) {
    return Repository.delete(`/action/${action_id}/statusLogs/${log_id}`)
  },
};
